import React, { useState } from 'react'
import Modal from '../../../../../components/modal'
import { FormField } from '../../../../../components/inputs'
import { Button } from '../../../../../components/button'
import { Errors, useVinSearch } from '../../../hooks/use-vin-search'
import useMyVehicles from '../../../../../hooks/use-my-vehicles'
import Router from 'next/router'

const EnterVinModal = ({ onSuccess, onClose, onManualEntry, onNotFound, onSeeInstructions }) => {
  const [vin, setVin] = useState('')

  const { search, isLoading, error } = useVinSearch({
    onSuccess: (vehicle) => {
      setVin('')
      onSuccess(vehicle)
    },
    onError: (error) => {
      if (error === Errors.VEHICLE_BY_VIN_NOT_FOUND) {
        onNotFound()
      }
    },
  })

  const URL = useMyVehicles(vin)

  const handleSearch = () => {
    if (URL) {
      Router.push(URL)
    } else {
      search(vin)
    }
  }

  return (
    <Modal onClose={onClose}>
      <div className='root'>
        <h2 className='title'>Enter your VIN</h2>
        <div className='input-container'>
          <FormField
            aria-label='vin'
            name='vin'
            placeholder='VIN'
            value={vin}
            onChange={(e) => setVin(e.target.value?.toUpperCase())}
            error={error}
          />
          {error === Errors.VIN_IS_NOT_VALID && (
            <div className='error'>Vin appears to be invalid, please try again.</div>
          )}
          {error === Errors.CANNOT_LOCATE_YOUR_VIN && (
            <div className='flex flexDirectionColumn alignCenter'>
              <div className='error'>
                We still cannot locate your VIN. If this is your correct VIN, please use the manual
                entry form to add your vehicle
              </div>
              <button className='flatBtn enter-details' onClick={onManualEntry}>
                Enter vehicle details
              </button>
            </div>
          )}
        </div>
        <div className='button-container'>
          <Button onClick={handleSearch} disabled={!vin || isLoading}>
            Continue
          </Button>
        </div>
        <div className='additional-buttons'>
          <button className='flatBtn' onClick={onManualEntry}>
            No VIN? Click here to enter your vehicle manually
          </button>
          <span> or </span>
          <button className='flatBtn' onClick={onSeeInstructions}>
            Help me find my VIN.
          </button>
        </div>
        <p className='terms'>
          Questions?{' '}
          <a className='mail' href='mailto:support@drivrzxchange.com'>
            Contact Support
          </a>
        </p>
      </div>
      <style jsx>{`
        .root {
          padding: 3.4rem 2rem;
          max-width: 100vw;
          width: 43.6rem;
          background: var(--primary-bg-color);
        }

        .title {
          text-align: center;
          font-size: 3.4rem;
          padding-bottom: 1rem;
        }

        .input-container {
          margin: 4.1rem 0;
        }

        .button-container {
          margin: 2.6rem 1.5rem;
          text-align: center;
        }

        .terms {
          padding: 1.2rem 0 1.4rem;
          line-height: 1.9rem;
          text-align: center;
          font-size: 1.4rem;

          .mail {
            color: var(--primary-color);
          }
        }

        .error {
          margin: 1.3rem 0 0;
          text-align: center;
          color: var(--alert-color);
          font-size: 1.4rem;
        }

        .enter-details {
          margin: 1rem 0 0;
          color: var(--text-link-color);
          font-size: 1.6rem;
        }

        .additional-buttons {
          margin: 2.1rem 0;
          text-align: center;
          font-size: 1.6rem;

          a,
          button {
            color: var(--text-link-color);
          }
        }

        @media (max-width: 1024px) {
          .root {
            max-width: 34.7rem;
            width: 100%;
            margin: 0 auto;
            height: 100%;
          }

          .title {
            font-size: 1.8rem;
          }

          .button-container {
            position: fixed;
            left: 0;
            bottom: 2.1rem;
            width: 100%;
          }

          .terms {
            font-size: 1.2rem;
          }

          .error {
            font-size: 1.2rem;
          }

          .enter-details {
            margin: 0.6rem 0 0;
            font-size: 1.4rem;
          }

          .additional-buttons {
            margin: 1rem 0;
            font-size: 1.4rem;
          }
        }
      `}</style>
    </Modal>
  )
}

export default EnterVinModal
